// Widget Scripts
import themeBackground from './js/widgets/1-themeBackground.js';
import customTicketButton from './js/widgets/0-customTicketButton.js';

import mainSlideshow from './js/widgets/2-mainSlideshow.js';

import * as eventsWidget from './js/widgets/3-events-widget/index.js';

import customCards from './js/widgets/4-customCards.js';

import * as seoSignup from './js/widgets/5-seo-signup/index.js';

import scrollerSponsors from './js/widgets/7-scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeBackground();
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    eventsWidget.autoEventFeed();
    // eventsWidget.manualEventFeed();
    customCards();
    seoSignup.customSeoBlock();
    seoSignup.customSignup();

    scrollerSponsors();
  }
});
